import {
  enableObservabilityAiFeatures,
  enableVegaWithoutGenAiTerms,
  vegaTermsAcceptanceMode,
} from '@gonfalon/dogfood-flags/dogfood-flags';

/** Whether to render an AI entry point at all — true when the account has some route to AI access. */
export const showAiEntryPoint = () => {
  const mode = vegaTermsAcceptanceMode();
  return enableObservabilityAiFeatures() || mode === 'self-serve-form' || mode === 'order-form-required';
};

/**
 * Whether the account may use Vega (O11Y-1972): GenAI terms accepted
 * (`isGeneralGenAiEnabled`) OR the `enable-vega-without-genai-terms` dogfood
 * flag, which will be targeted at BYOK customers — their inference runs on
 * their own keys, so the GenAI terms don't apply. Use this at Vega entry points
 * only — non-Vega AI features run on LD-managed inference and must stay on the
 * raw account setting.
 */
export const hasVegaAiAccess = (account: { isGeneralGenAiEnabled?: boolean }) =>
  Boolean(account.isGeneralGenAiEnabled) || enableVegaWithoutGenAiTerms();
